import { AreaPickerStartOptions, IAreaPickerService } from './IAreaPickerService';
import { logger } from '@common/logging/logger';

export class AreaPickerServiceExceptionDecorator implements IAreaPickerService {
  private decoree: IAreaPickerService;

  constructor(decoree: IAreaPickerService) {
    this.decoree = decoree;
  }

  start(options: AreaPickerStartOptions): symbol {
    try {
      return this.decoree.start(options);
    } catch (err) {
      this.logError('start', err);
      return Symbol('area-pick-failed');
    }
  }

  complete(areaId: string): void {
    try {
      this.decoree.complete(areaId);
    } catch (err) {
      this.logError('complete', err);
    }
  }

  refresh(enabledAreaIds: string[]): void {
    try {
      this.decoree.refresh(enabledAreaIds);
    } catch (err) {
      this.logError('refresh', err);
    }
  }

  cancel(token: symbol): void {
    try {
      this.decoree.cancel(token);
    } catch (err) {
      this.logError('cancel', err);
    }
  }

  abort(): void {
    try {
      this.decoree.abort();
    } catch (err) {
      this.logError('abort', err);
    }
  }

  isActive(): boolean {
    try {
      return this.decoree.isActive();
    } catch (err) {
      this.logError('isActive', err);
      return false;
    }
  }

  private logError(methodName: string, error: unknown): void {
    logger.error(`AreaPickerService.${methodName} failed:`, error);
  }
}
